import React, { Component, ReactNode } from 'react';

interface Props extends Record<string, unknown> {
    children: ReactNode;
    renderChildrenWithError: boolean;
}
interface State {
    hasError: boolean;
}

// From https://reactjs.org/docs/error-boundaries.html
export class ErrorBoundary extends Component<Record<string, unknown>, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(/* error */): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: unknown): void {
        // eslint-disable-next-line no-console
        console.error(
            'In ErrorBoundary, caught error:\n',
            error,
            '\n\nerrorInfo:\n',
            errorInfo,
        );
    }

    render(): ReactNode {
        const {
            state: { hasError },
        } = this;
        const {
            props: { children, renderChildrenWithError },
        } = this;

        if (hasError && !renderChildrenWithError) {
            return <h1>ErrorBoundary</h1>;
        }

        return children;
    }
}
